import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom"
import LoginComponent from "./Components/LoginComponent";
import RegistroComponent from "./Components/RegistroComponent";
import UserViewComponent from "./Components/UserViewComponent";
import PanelViewComponent from "./Components/PanelViewComponent";

function App() {
  return (
    <div className="App">
        <Routes>
            <Route path="/"  element={<LoginComponent />} />
            <Route path="/registro" element={<RegistroComponent />} />
            <Route path="/mi_avance" element={<UserViewComponent />} />
            <Route path="/panel_avance" element={<PanelViewComponent />} />
        </Routes>
    </div>
  );
}

export default App;
